import baseRequest from "./baseReuqest";

export function getBxLinkFunnels() {
    return baseRequest(`/api/get-bxlink-funnels`);
}
export function getBxLinkFunnelStages(funnelId) {
    return baseRequest(`/api/get-bxlink-funnel-stages/${funnelId}`);
}
